import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plc-landing-page-logo',
  templateUrl: './landing-page-logo.component.html',
  styleUrls: ['./landing-page-logo.component.scss']
})
export class LandingPageLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
